import { createSelector } from 'reselect';
import { flatten, isEmpty, find } from 'underscore';

// @ts-expect-error untyped dependency
import { getFormFields } from 'FormsUI/selectors/FormDefinition';
import { getPropertyId, getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
const getFormFieldId = (state, props) => props.formFieldId;
export const getDependentFieldForId = createSelector([getFormFields, getFormFieldId], (formFields, formFieldId) => {
  const dependentFieldsFilters = flatten((formFields || []).map(el => el.dependentFieldFilters));
  const dependentFields = flatten((dependentFieldsFilters || []).map(el => el.dependentFormField));
  return find(dependentFields, field => {
    return getPropertyObjectTypeId(field) === formFieldId;
  });
});
export const getDependentFieldsWithParent = createSelector([getFormFields], formFields => {
  return formFields.filter(formField => !isEmpty(formField.dependentFieldFilters)).reduce((acc, formField) => {
    const propertyId = getPropertyObjectTypeId(formField);
    acc[propertyId] = formField;
    const dependentFields = flatten((formField.dependentFieldFilters || []).map(el => el.dependentFormField));
    dependentFields.forEach(dependentField => {
      acc[getPropertyId(dependentField)] = dependentField;
    });
    return acc;
  }, {});
});